(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-list-collections"]) return;
  try {
    
  if (window.location.href.endsWith('/collections') || window.location.href.endsWith('/collections/')) {
    window.location.href = '/collections/frontpage';
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["omnes-sus-page_navigation"] && !Shopify.designMode) return;
  try {
    
  (async() => {
    while(!window.hasOwnProperty("jQuery")) {
      await new Promise(resolve => setTimeout(resolve, 100));
    }

    $('[data-section_title]').each(function () {
      let navsection = this;
      $('#myScrollspy ul').append('<li class="nav-item"><a href="#'+$(navsection).attr('id')+'" class="nav-link">'+ $(navsection).data('section_title') +'</a></li>');
    });

    $('body').addClass('dark-menu');

    $('body').attr('data-bs-spy','scroll');
    $('body').attr('data-bs-target','#myScrollspy');
    $('body').attr('tabindex','0');
    //$('body').attr('data-bs-smooth-scroll','true');

    $(window).on('scroll', function(event) {
      let positions = []
      $('#myScrollspy a').each(function () {
        let id2check = $(this).attr('href')
        let el2check = $(id2check).get()[0];
        const rect = el2check.getBoundingClientRect();
        if (rect.top>0) {
          positions.push({'id': id2check, 'top': rect.top})
        }        
      })
      const active = positions.reduce((prev, current) => (prev.top < current.top) ? prev : current, 0);

      $('#myScrollspy a').removeClass('active');
      $('#myScrollspy').find('a[href="'+active.id+'"]').addClass('active');
    })

/*
    $('[data-bs-spy="scroll"]').on('activate.bs.scrollspy', function (event) { 
      console.log('data-bs-spy...', event.relatedTarget)
    })

    const bodyEl = document.getElementsByTagName("body")[0]
    var scrollSpy = bootstrap.ScrollSpy.getOrCreateInstance(bodyEl)
    
    $('[data-bs-spy="scroll"]').on('activate.bs.scrollspy', function (event) { 
      console.log('data-bs-spy...', event.relatedTarget)

    })
    //console.log(scrollSpy);
    */
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-delivery"]) return;
  try {
    
  (async() => {
      while(!window.hasOwnProperty("jQuery")) {
        await new Promise(resolve => setTimeout(resolve, 100));
      }
      $('[data-delivery2do]').each(function () {
        let item = $(this).detach();
        item.appendTo('#accordionDelivery');
      });
      $('#accordionDelivery').find('.accordion-item').first().find('.accordion-button').removeClass('collapsed');
      $('#accordionDelivery').find('.accordion-item').first().find('.accordion-button').attr("aria-expanded", "false");
      $('#accordionDelivery').find('.accordion-item').first().find('.accordion-collapse').addClass('show');

      $('#accordionDelivery').find('.accordion-item').removeClass('d-none');
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faq"]) return;
  try {
    
  (async() => {
      while(!window.hasOwnProperty("jQuery")) {
        await new Promise(resolve => setTimeout(resolve, 100));
      }

      $('[data-faq2do]').each(function () {
        $('#faq-list').append('<a href="#'+ $(this).attr('id') +'">'+ $(this).find('.accordion-title').html() +'</a>');
        let item = $(this).detach();
        item.appendTo('#faq-content-list');
      });

      $('body').attr('data-bs-spy','scroll');
      $('body').attr('data-bs-target','#faq-list');
      $('body').attr('tabindex','0');
/*
      $('body').attr('data-bs-offset','300');
      $('body').attr('data-bs-smooth-scroll','true');
      $('body').attr('data-bs-root-margin','0px 0px -75%');
*/
      $('#faq-content-list').find('.section').removeClass('d-none');

      $(window).on('scroll', function(event) {
        let positions = []
        $('#faq-list a').each(function () {
          let id2check = $(this).attr('href')
          let el2check = $(id2check).get()[0];
          const rect = el2check.getBoundingClientRect();
          if (rect.top>0) {
            positions.push({'id': id2check, 'top': rect.top})
          }        
        })
        const active = positions.reduce((prev, current) => (prev.top < current.top) ? prev : current, 0);
        //console.log(positions, active)

        $('#faq-list a').removeClass('active');
        $('#faq-list').find('a[href="'+active.id+'"]').addClass('active');
      })

     /*
      const bodyEl = document.getElementsByTagName("body")[0]
      var scrollSpy = bootstrap.ScrollSpy.getOrCreateInstance(bodyEl)
       bodyEl.addEventListener('activate.bs.scrollspy', function () {
        console.log('activate.bs.scrollspy');
      })
      window.addEventListener('activate.bs.scrollspy', function (e) {
        console.log(e.relatedTarget);        
      });
      $('[data-bs-spy="scroll"]').on('activate.bs.scrollspy', function () { 
        console.log('data-bs-spy...')
      })
      */

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-offer-bar"] && !Shopify.designMode) return;
  try {
    
    window.addEventListener('load', (event) => {
        const thisBar = document.querySelector('.shoplift-offer--bar--sticky');

        if (thisBar != null) {
            const thisHeader = document.querySelector('.shoplift-offerbar-wrapper');
            thisHeader.classList.add("shoplift-offer-bar-sticky");

            const mainHeader = document.querySelector('#shopify-section-header > sticky-header');

            const mainInitialTop = mainHeader.offsetTop;
            const stickyStart = mainHeader ? (mainHeader.offsetTop + mainHeader.clientHeight) : 0;
            let lastScroll = window.scrollY;
            document.addEventListener("scroll", (scrollEvent) => {
                if (!thisHeader) return;

                // Do it quick and dirty
                const mainHidden = mainHeader && (window.scrollY > lastScroll);
                lastScroll = window.scrollY;

                const makeSticky = window.pageYOffset > stickyStart || mainHeader && window.pageYOffset > mainInitialTop && mainHeader.parentElement.classList.contains("shopify-section-header-sticky");

                thisHeader.classList.toggle("shoplift-offer-bar-sticky", makeSticky);

                if (!makeSticky) return;

                let topPosition = 0;

                if (mainHeader && !mainHidden)
                    topPosition += mainHeader.clientHeight;

                thisHeader.style.top = topPosition + "px";
            });
        }
    });

  } catch(e) { console.error(e); }
})();
})();
